import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
// import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { RegisterMixtapeService } from '@shared/services/register-mixpanel/register-mixtape.service';
import { TooltipModule } from 'primeng/tooltip';


@Component({
    selector: 'tooltip-info',
    templateUrl: './tooltip-info.component.html',
    standalone: true,
    imports: [TooltipModule]
})
export class TooltipInfoComponent implements OnInit, OnChanges {
  custom: any = this.customLanding.getCustom();
  isLanding: boolean = this.customLanding.isLanding();
  tooltipInfo: any = {
    showInfo: false,
    descriptionTooltip: '',
    id: this.commonUtilsService.createId()
  }
  constructor(private route: ActivatedRoute,
    private modalService:ModalServiceService,
    private apiService:ApiServiceService,
    private registerService:RegisterMixtapeService,
    private customLanding: CustomLandingFactory,
    private commonUtilsService: CommonUtilsService,
    private context: ContextFactory
    // private sanitize: DomSanitizer
  ) { }

  @Input() field:any;
  @Input() concept:any;
  @Input() description:string;
  @Input() id:string;
  @Input() isSequentialPoll:string;
  @Input() tooltipPosition:string='top';
  @Input() disabled: boolean = false;

  ngOnInit(){
    if(this.description && this.description.indexOf('<a') !== -1){
      this.formatDescription();
      window.addEventListener('click', (event: any)=>{
        if(event.target.className.indexOf(this.tooltipInfo.id) !== -1){
          let type = '(click)="openRelated(';
          let linkHtml: any = event.target.outerHTML;
          let position = linkHtml.indexOf(type)+type.length;
          let position2 = linkHtml.indexOf('}')-position+1;
          let item = linkHtml.substr(position, position2);
          item = JSON.parse(item.replaceAll("'", '"'));
          this.openRelated(item);
        }
      })
    }else{
      this.tooltipInfo.descriptionTooltip = this.description;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['description']) {
      this.formatDescription();
    }
  }

  formatDescription() {
    let description = this.extractRelatedOrReferences('data-related="', this.description);
    this.tooltipInfo.descriptionTooltip = this.extractRelatedOrReferences('data-references="', description);
  }

  extractRelatedOrReferences(type:string, description:string){
    if(description.indexOf(type) !== -1){
      let aSplit = description.split('<a ');
      for(let i = 0; i < aSplit.length; i++){
        let aTag = aSplit[i];
        aTag = aTag.replace('href="#"','');
        aTag = aTag.replace(type,'(click)="openRelated(');
        aSplit[i] = aTag.replace('common__tiny-link','common__tiny-link ' + this.tooltipInfo.id);
      }
      return aSplit.join('<a ');
    }else{
      return description;
    }
  }

  openRelated(item:any){
    if(item.modal === 'related-information'){
      this.modalService.relatedInformationModal(item);
    }else{
      this.openReferences(item)
    }
  }

  openReferences(item:any){
    if(this.concept && this.concept.title){
      this.registerEvent(this.concept.title, item);
    }else if(this.field && this.field.conceptTitle){
      this.registerEvent(this.field.conceptTitle, item);
    }else{
      this.getConcept(item);
    }
  }

  getConcept(item: any){
    let evaluationId = this.field && this.field.evaluationId?this.field.evaluationId: this.route.snapshot.params['evaluationId'];
    this.apiService.get("fields/getconceptbyfieldid/" + evaluationId + "/", this.field.fieldId)
      .then((data:any) => {
        this.registerEvent(data.title, item);
      }, (error:any) => {
        console.error(error);
      });
  }

  registerEvent(title:any, item: any){
    // let loginInfo = JSON.parse(sessionStorage['loginInfo']);
    let registerItem = {
      event: 'open field description',
      conceptName: sessionStorage['breadcrumbConcept'] + title
    }
    this.registerService.register(registerItem);
    this.modalService.lawInfoModal(registerItem, [item]);
  }
}
